<template>
    <div class="tablePmm">
        <table class="table pmmTable" v-if="lastSelectTradingAccount != '' && lastSelectTradingAccount[0].platform == 'ACT'">
            <thead>
                <tr>
                    <th>{{$t('orderId')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('accountId')}}</th>
                    <th>{{$t('quantity')}}</th>
                    <th>{{$t('price')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('type')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('triggered')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('side')}}</th>
                    <th>{{$t('tradeId')}}</th>
                    <th>{{$t('openTime')}}</th>
                </tr>
            </thead>
            <tbody v-if="'open_orders' in accountDetails && accountDetails.open_orders.length >0">
                <tr v-for="list in accountDetails.open_orders" >
                    <td>{{list.OrderID}}</td>
                    <td>{{list.Symbol}} </td>
                    <td>{{list.AccountID}}</td>
                    <td>{{list.Quantity}}</td>
                    <td>{{list.Price}}</td>
                    <td v-if="pageName != 'dashboard'">{{list.Type}}</td>
                    <td v-if="pageName != 'dashboard'">{{list.Triggered}}</td>
                    <td v-if="pageName != 'dashboard'">{{list.Side}}</td>
                    <td>{{list.TradeID}}</td>
                    <td>{{timeFunc(list.OpenTime)}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr >
					<td class="noRecordFound"  colspan="10"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span" :list="accountDetails" v-else></loader-component>-->
        </table>
        
        <table class="table pmmTable" v-else>
            <thead>
                <tr>
                    <th>{{$t('login')}}</th>
                    <th>{{$t('order')}}</th>
                    <th>{{$t('symbol')}}</th>
                    <th>{{$t('openPrice')}}</th>
                    <th>{{$t('closePrice')}}</th>
                    <th>{{$t('profit')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('volume')}}</th>
                    <th>{{$t('openTime')}}</th>
                    <th>{{$t('closeTime')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('comment')}}</th>
					<th v-if="pageName != 'dashboard'">{{$t('commision')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('agentComm')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('cmd')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('sl')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('tp')}}</th>
                    <th v-if="pageName != 'dashboard'">{{$t('swaps')}}</th>
                </tr>
            </thead>
            <tbody v-if="accountDetails != '' &&  'open_orders' in accountDetails && Object.keys(accountDetails.open_orders).length > 0 && accountDetails.open_orders.csv_array.length > 0">
                <tr v-for="list in accountDetails.open_orders.csv_array" >
                    <td>{{list[0]}}</td>
                    <td>{{list[1]}} </td>
                    <td>{{list[2]}}</td>
                    <td>{{list[3]}}</td>
                    <td>{{list[4]}}</td>
                    <td >{{list[5]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[6]}}</td>
                    <td >{{timeFunc(list[7])}}</td>
                    <td>{{list[8]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[9]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[10]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[11]}} </td>
                    <td v-if="pageName != 'dashboard'">{{list[12]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[13]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[14]}}</td>
                    <td v-if="pageName != 'dashboard'">{{list[15]}}</td>
                </tr>
            </tbody>
			<tbody v-else>
				<tr >
					<td class="noRecordFound"  colspan="17"> 
						<img src="../../../../../static/fxView/images/search.svg" alt="no record found">
						<p>{{$t('thereIsNoRecord')}}</p>
					</td>
				</tr>
			</tbody>
            <!--<loader-component :pageloader_value="'false'" :type="'table'" :colspan="col_span1" :list="accountDetails" v-else></loader-component>-->
        </table>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const }  from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import moment from 'moment'
    export default {
        name: 'Open-Orders',
        mixins: [fxViewMixins],
		props:['pageName'],
        data() {
            return {col_span : 10 ,col_span1 : 17}
        },
		methods:{
			timeFunc(getData){
				return moment.unix(getData).format("DD-MM-YYYY, h:mm:ss");
			}
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/open_orders_listing.vue